<!--  -->
<template>
  <div class="all_box">
    <div class="search_box">
      <div>
        <el-input v-model="query.keyword" style="width:200px;margin-right:10px" placeholder="请输入内容" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="resast">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addzhuan">新增转盘</el-button>
      </div>
    </div>

    <div class="tanwrbox">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="ID"
          width="50"
          align="center"
        />
        <el-table-column
          prop="title"
          label="标题"
          width="180"
          align="center"
        />
        <el-table-column
          prop="customer_service_url"
          label="联系客服url"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <!-- <p>{{ scope.row.customer_service_url }}</p> -->
            <el-popover
              placement="top-start"
              title="联系客服url"
              width="200"
              trigger="hover"
              :content="scope.row.customer_service_url"
            >
              <p slot="reference" style="width:122px" class="titip">{{ scope.row.customer_service_url }}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="se"
          label="玩法说明"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <!-- <p>{{ scope.row.playInstructions }}</p> -->
            <el-popover
              placement="top-start"
              title="玩法说明"
              width="200"
              trigger="hover"
              :content="scope.row.play_instructions"
            >
              <p slot="reference" class="titip">{{ scope.row.play_instructions }}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="raffle_number"
          label="每日抽奖次数"
          align="center"
          width="80"
        />
        <el-table-column
          prop="immediately_number"
          label="立即抽奖次数"
          align="center"
          width="80"
        />
        <el-table-column
          prop="book_currency_exchange"
          label="书币兑换门槛=每次扣除数 普通用户"
          align="center"
          width="110"
        />
        <el-table-column
          prop="book_currency_exchange_vip"
          label="书币兑换门槛=每次扣除数 vip用户"
          align="center"
          width="110"
        />
        <el-table-column
          prop="exchange_number"
          label="每月最多兑换次数"
          align="center"
          width="80"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
          width="160"
        />
        <el-table-column
          prop="updated_at_text"
          label="修改时间"
          align="center"
          width="160"
        />
        <!-- <el-table-column
          prop="backgroundPicUrl"
          label="背景图片"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <img :src="scope.row.backgroundPicUrl" style="width:80px;height:80px">
          </template>
        </el-table-column> -->
        <el-table-column
          prop="status_text"
          label="状态"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 9" class="el-icon-delete-solid stopew" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="创建人"
          align="center"
          width="80"
        />
        <!-- <el-table-column
          prop="status"
          label="状态"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.status"
                :width="60"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              />
              <div
                v-if="scope.row.status === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >启用</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >禁用</div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editclick(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
            <!-- <el-button type="primary" size="mini" @click="lookwinprize">查看中奖记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <el-dialog
      title="转盘"
      :visible.sync="dialogVisible"
      width="53%"
      :destroy-on-close="true"
    >
      <addturntable ref="addturntabledialog" @close="close" />
    </el-dialog>
  </div>

</template>

<script>
import addturntable from './components/addturntable.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { turntablelist, delturntableconfig } from '@/api/sourceMaterial.js'
export default {
  components: {
    addturntable,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false, // 新增转盘弹窗
      tableData: [],
      query: {
        page: 1,
        page_size: 10,
        keyword: null
      },
      total: null
    }
  },
  created() {
    this.getlist()
  },
  mounted() {

  },
  methods: {
    // 新增转盘
    addzhuan() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addturntabledialog.send(1)
      }, 100)
    },
    // 编辑转盘
    editclick(item) {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addturntabledialog.send(2, item)
      }, 100)
    },
    // 状态的更改
    statusChange(val) {
      console.log('val', val)
    },
    // 跳转中奖记录
    lookwinprize() {
      this.$router.push({ path: '/winprize/index', query: { id: '1' }})
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getlist()
    },
    async getlist() {
      const data = await turntablelist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    close() {
      this.dialogVisible = false
      this.getlist()
    },
    search() {
      this.query.page = 1
      this.getlist()
    },
    resast() {
      this.query.page = 1
      this.query.pageSize = 10
      this.query.keyword = null
      this.getlist()
    },
    deleter(id) {
      this.$confirm('此操作将删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delturntableconfig({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.all_box{
  padding: 20px;
}
.tanwrbox{
  margin-top: 15px;
}
.titip{
    width: 152px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
